import { MouseEvent, useState } from 'react'
import clsx from 'clsx'
import { Moon, Sun } from 'lucide-react'

const readIsDark = () => document.documentElement.classList.contains('dark')

export const ThemeToggle = () => {
  const [dark, setDark] = useState(readIsDark)

  const applyTheme = (nextDark: boolean) => {
    document.documentElement.classList.toggle('dark', nextDark)
    setDark(nextDark)
  }

  const onToggle = (e: MouseEvent<HTMLButtonElement>) => {
    const nextDark = !dark
    const root = document.documentElement
    root.style.setProperty('--transition-x', `${e.clientX}px`)
    root.style.setProperty('--transition-y', `${e.clientY}px`)

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion || typeof document.startViewTransition !== 'function') {
      applyTheme(nextDark)
      return
    }

    document.startViewTransition(() => {
      applyTheme(nextDark)
    })
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      onClick={onToggle}
      className="tw-inline-flex tw-h-6 tw-w-11 tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-transition-colors tw-duration-200"
      style={{
        backgroundColor: dark ? 'var(--primary-500)' : 'var(--input-bg)',
        border: '1px solid var(--page-border)',
      }}
    >
      <span
        className={clsx(
          'tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-shadow tw-transition-transform tw-duration-200',
          dark ? 'tw-translate-x-[22px]' : 'tw-translate-x-[1px]',
        )}
        style={{ backgroundColor: '#ffffff' }}
      >
        {dark ? <Moon size={12} color="#1f2937" /> : <Sun size={12} color="#b45309" />}
      </span>
    </button>
  )
}
